const rail = {
  rails: "Rieles", // translated
  senior: "Sénior", // translated
  seniors: "personas mayores", // translated
  youths: "jóvenes", // translated
  yearOld: "años de edad", // translated
  yearsOld: "años", // translated
};


export default rail;
